export default __webpack_public_path__ + "static/8-0074657962bd36892ffe1f0cdfcee9dd.png";